const Ziggy = {"url":"http:\/\/localhost:8080","port":8080,"defaults":{},"routes":{"cashier.payment":{"uri":"stripe\/payment\/{id}","methods":["GET","HEAD"]},"cashier.webhook":{"uri":"stripe\/webhook","methods":["POST"]},"dashboard":{"uri":"dashboard","methods":["GET","HEAD"]},"login":{"uri":"login","methods":["GET","HEAD"]},"password.confirm":{"uri":"confirm-password","methods":["GET","HEAD"]},"logout":{"uri":"logout","methods":["POST"]}}};

if (typeof window !== 'undefined' && typeof window.Ziggy !== 'undefined') {
    Object.assign(Ziggy.routes, window.Ziggy.routes);
}

export { Ziggy };
